// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar_content {\n  width: 100%;\n  max-width: 100vw;\n  padding-bottom: 20px; }\n  .calendar_content .no_data_msg {\n    border: 1px solid #292727;\n    padding: 30px;\n    background-color: #e5e7eb;\n    margin: 10px auto -5px;\n    width: 200px; }\n\n.body {\n  overflow-x: scroll; }\n\n.headers {\n  margin-bottom: 1rem;\n  overflow-x: hidden;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 10.06255rem;\n  z-index: 999; }\n", ""]);
// Exports
module.exports = exports;
